var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rightclassroomArrangement" }, [
    _c("div", { staticClass: "title-label" }, [
      _c("div", [_vm._v("未开始课程/会议")]),
      _c(
        "div",
        { staticClass: "more", on: { click: _vm.clickMore } },
        [
          _c("div", [_vm._v("更多")]),
          _c("van-icon", {
            attrs: { name: "arrow", size: "0.14rem", color: "#999" },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "rightpage-content" }, [
      _vm.data.length > 0
        ? _c("div", { staticClass: "swiper-containerFocus" }, [
            _c(
              "div",
              { staticClass: "swiper-wrapper" },
              _vm._l(_vm.data, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "swiper-slide" },
                  _vm._l(item, function (innerItem, innerIndex) {
                    return _c(
                      "div",
                      {
                        key: innerIndex,
                        staticClass: "inneritem",
                        style: {
                          marginRight: (innerIndex == 0 ? "0.15" : "") + "rem",
                        },
                      },
                      [
                        _c("classroomArrangementItem", {
                          attrs: { item: innerItem, isCurrent: false },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                )
              }),
              0
            ),
            _c("div", { staticClass: "swiper-pagination" }),
          ])
        : _c("div", { staticClass: "arrange-nodata" }, [
            _c("div", { staticClass: "content" }, [
              _c("img", {
                attrs: {
                  src: require("_teas/public/img/product/bootScreen/img-null.png"),
                  alt: "",
                  srcset: "",
                },
              }),
              _c("div", { staticClass: "text" }, [_vm._v("暂无课程/会议")]),
            ]),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }